import { ReactNode } from 'react';
import { Skeleton, Stack } from '@mui/material';
import { useDashboardTFunction } from '@retail/dashboard/i18n';
import { BlockState } from './BlockState';
import { BlockErrorState } from './BlockErrorState';

interface Props {
  isLoading?: boolean;
  isError?: boolean;
  isEmpty?: boolean;
  emptyMessage?: ReactNode;
  onRetry?: () => void;
  children?: ReactNode;
}

export const BlockBody = ({
  isLoading,
  isError,
  isEmpty,
  emptyMessage,
  onRetry,
  children,
}: Props) => {
  const t = useDashboardTFunction();

  if (isError) {
    return <BlockErrorState message={t('dashboard.messages.error')} onRetry={onRetry} />;
  }
  if (isLoading) {
    return (
      <Stack gap={1.5} sx={{ flexGrow: 1, py: 1 }}>
        <Skeleton variant="rounded" height={28} width="60%" />
        <Skeleton variant="rounded" height={16} />
        <Skeleton variant="rounded" height={16} width="80%" />
        <Skeleton variant="rounded" sx={{ flexGrow: 1, minHeight: 48 }} />
      </Stack>
    );
  }
  if (isEmpty) {
    return <BlockState>{emptyMessage ?? t('dashboard.messages.noData')}</BlockState>;
  }
  return children;
};
